import { connectFela } from '../../dependencies';
import PickCompany from './PickCompany';
import * as styles from './PickCompany.styles';

export default connectFela(styles)(PickCompany);
